/**
 * Threat intelligence — shared contracts (server feeds, device protection, console).
 * See docs/design/security-roadmap-v1.md.
 */

/** Security categories (web / download / extension protection). Advertising is deliberately absent. */
export const SECURITY_CATEGORIES = [
  'malware',
  'phishing',
  'credential_theft',
  'c2',
  'cryptomining',
  'scam',
  'malicious_redirect',
  'malicious_extension',
] as const;
export type SecurityCategory = (typeof SECURITY_CATEGORIES)[number];

/** Privacy categories (Phase 6, off by default). */
export const PRIVACY_CATEGORIES = ['tracker', 'fingerprinting'] as const;

export const THREAT_CATEGORIES = [...SECURITY_CATEGORIES, ...PRIVACY_CATEGORIES] as const;
export type ThreatCategory = (typeof THREAT_CATEGORIES)[number];

export const INDICATOR_TYPES = ['domain', 'url', 'sha256', 'extension_id'] as const;
export type IndicatorType = (typeof INDICATOR_TYPES)[number];

export const INDICATOR_CONFIDENCE = ['high', 'medium', 'low'] as const;
export type IndicatorConfidence = (typeof INDICATOR_CONFIDENCE)[number];

/**
 * One normalised indicator.
 *  domain        lower-case, IDNA/punycode, no trailing dot, no port ("login.example-bad.com")
 *  url           normalised absolute http(s) URL (lower-case scheme+host, no fragment)
 *  sha256        64 lower-case hex chars
 *  extension_id  32 chars a–p (Chromium id)
 */
export interface ThreatIndicator {
  type: IndicatorType;
  value: string;
  category: ThreatCategory;
  /** Feed id (e.g. "abusech-urlhaus") or "org-list:<uuid>" for an organisation's own list. */
  source: string;
  confidence: IndicatorConfidence;
  /** Human reference (feed entry URL / note), never secrets. */
  reference: string | null;
}
